import { render, staticRenderFns } from "./MerchantUsers.vue?vue&type=template&id=c10bc142&scoped=true"
import script from "./MerchantUsers.vue?vue&type=script&lang=js"
export * from "./MerchantUsers.vue?vue&type=script&lang=js"
import style0 from "./MerchantUsers.vue?vue&type=style&index=0&id=c10bc142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10bc142",
  null
  
)

export default component.exports